import Card from "../Card";
import { Typography, useMediaQuery } from "@mui/material";
import { Container, Content, Flag, Footer, Image } from "./styled";
import { LibraryCardProps } from "./types";

export default function LibraryCard({
  flagText,
  title,
  content,
  imageSrc,
  onClick,
}: LibraryCardProps) {
  const isMobileOrTablet = useMediaQuery("(max-width: 1024px)");
  return (
    <Card
      color="bhBlue95"
      headerContent={
        <Flag>
          <Typography variant="body4">{flagText}</Typography>
        </Flag>
      }
      style={{
        cursor: "pointer",
        transition: "background-color 0.3s ease",
        ...((!isMobileOrTablet && {
          "&:hover": {
            bgcolor: "natural95.main",
          },
        }) ||
          {}),
        "&:active": {
          bgcolor: "natural95.main",
        },
      }}
      onClick={onClick}
      contentStyle={{
        flex: 1,
        marginBottom: "0px",
        padding: "5px",
      }}
    >
      <Container>
        <Content>
          <Typography variant="h3Medium">{title}</Typography>
          <Typography variant="body1" color={"neutral40.main"}>
            {content}
          </Typography>
        </Content>
        <Footer>
          <Image src={imageSrc} />
        </Footer>
      </Container>
    </Card>
  );
}
